var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",staticStyle:{"height":"calc(100vh - 96px)","max-height":"calc(100vh - 96px)","overflow-y":"hidden","width":"100%"},attrs:{"fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }